module.exports = "./img/d0762706cade76a4196efcafc45afc31.jpg";